"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleImageClient = void 0;
class VehicleImageClient {
    constructor(vehicleImageUrlBuilder, authService, stage) {
        this.vehicleImageUrlBuilder = vehicleImageUrlBuilder;
        this.authService = authService;
        this.stage = stage;
    }
    async getImages(vehicle) {
        const imageServiceUrl = this.vehicleImageUrlBuilder.getUrlForImageRequestWithDefaultView(vehicle);
        const response = await this.authService.get(`myvw-vilma-proxy-${this.stage}`, imageServiceUrl);
        if (response.ok) {
            return (await response.json());
        }
        throw new Error(await response.text());
    }
}
exports.VehicleImageClient = VehicleImageClient;
//# sourceMappingURL=VehicleImageClient.js.map